<template>
    <div class="tw-flex-col tw-h-full tw-flex tw-pt-2" :class="{'tw-items-center tw-justify-center': question.type === 'true_false' || question.type === 'free_form'}">
        <h2 class="quiz-question tw-text-gray-700 tw-text-xl tw-font-semibold tw-mb-8 tw-leading-normal">{{ question.question }}</h2>

        <div class="tw-flex tw-flex-wrap tw-pb-6" v-if="question_media.length > 0">
            <question-media v-for="media in question_media" :media="media" v-if="question.id === media.question_id" :key="media.id"></question-media>
        </div>

        <component :is="question.type" :question="question" :exact_answer="exact_answer"></component>

        <div class="answer-confirmed-overlay tw-absolute tw-z-10 tw-top-0 tw-left-0 tw-w-full tw-h-full" v-if="answered"></div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        props: ['question', 'quiz', 'current_question_index', "exact_answer"],

        computed: {
            ...mapState('quiz',
                ['question_media',
                 'answer_confirmed']
            ),

            answered() {
                return typeof this.$store.getters['quiz/getQuestionProgress'](this.question.id) !== 'undefined';
            }
        },

        mounted() {
            let media = this.$store.getters['quiz/getQuestionMedia'](this.question.id);

            if(media === false || typeof media === "undefined") {
                //this.$store.dispatch('quiz/getQuestionMedia', this.question.id);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .quiz-wrapper {
        .answer-confirmed-overlay {
            background: rgba(255, 255, 255, 0.4);
        }
    }
</style>